import { render, staticRenderFns } from "./ConnectionInfo.vue?vue&type=template&id=63926042&scoped=true&lang=html&"
import script from "./ConnectionInfo.vue?vue&type=script&lang=coffee&"
export * from "./ConnectionInfo.vue?vue&type=script&lang=coffee&"
import style0 from "./ConnectionInfo.vue?vue&type=style&index=0&id=63926042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63926042",
  null
  
)

component.options.__file = "ConnectionInfo.vue"
export default component.exports